import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Target, ShieldCheck, CreditCard } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-82" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-83" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-2 pb-6 px-4 md:pt-3 md:pb-8 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-84">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(74,222,128,0.15) 0%, rgba(74,222,128,0.05) 40%, transparent 70%)'
    }} data-id="element-85" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-86">
        <span className="inline-block py-1 px-3 rounded-full bg-mint/10 text-mint font-semibold text-sm mb-2 tracking-wide uppercase" data-id="element-87">
          🥑Salud en tu Plato™
        </span>

        <h1 className="md:text-6xl lg:text-7xl mb-3 font-[900] font-['Open_Sans',_sans-serif] text-dark text-[24px]" data-id="element-88">
          Tu año de nutrición listo
        </h1>

        <div className="mb-3 flex justify-center" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/1yVTPXdxV9wEn4QnnpjhT6/fb7ae9d7-3e5a-45d5-b6a7-5f30750f75e6.png" alt="Megapack Nutricionistas - Kit Profesional Completo" className="w-full max-w-[500px] md:max-w-xl drop-shadow-2xl pl-[55px] pr-[55px]" data-id="element-90" />
        </div>

        <p className="md:text-3xl italic text-mint mb-3 max-w-4xl mx-auto font-[800] font-[Avenir,_sans-serif] text-[14px]" data-id="element-91">
          Todo lo que necesitás para atender con más orden, responder con
          seguridad y ahorrar horas de preparación entre pacientes.
        </p>

        <motion.a href="#oferta-plus" whileHover={{
        scale: 1.02,
        boxShadow: '0 0 25px rgba(74,222,128,0.4)'
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-gradient-to-r from-mint to-secondary hover:from-mint/90 hover:to-secondary/90 text-white font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-xl shadow-lg shadow-mint/30 transition-all border border-mint/30" data-id="element-92">
          QUIERO EL MEGAPACK AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-3 mt-3" data-id="element-93">
          <div className="flex items-center gap-1.5 text-dark/60 text-sm font-medium" data-id="element-94">
            <Target size={16} className="text-mint" data-id="element-95" />
            Enfoque real
          </div>
          <div className="flex items-center gap-1.5 text-dark/60 text-sm font-medium" data-id="element-96">
            <ShieldCheck size={16} className="text-mint" data-id="element-97" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-dark/60 text-sm font-medium" data-id="element-98">
            <CreditCard size={16} className="text-mint" data-id="element-99" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}